// product-meta-info.js (ultra optimized, same behavior)

const IDLE_TIMEOUT_MS = 1200;

let formatter;
let lang = "en";

// -------------------- INIT --------------------

document.addEventListener("DOMContentLoaded", () => {
  runWhenIdle(initProductMetaInfo);
});

function runWhenIdle(fn) {
  if ("requestIdleCallback" in window) {
    requestIdleCallback(fn, { timeout: IDLE_TIMEOUT_MS });
  } else {
    setTimeout(fn, 50);
  }
}

// -------------------- CORE INIT --------------------

function initProductMetaInfo() {
  lang = document.documentElement.lang.startsWith("it") ? "it" : "en";

  formatter = new Intl.NumberFormat(lang, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  updateShippingText();
  updateRate();

  document.addEventListener("variant:change", onVariantChange, { passive: true });
}

// -------------------- EVENT HANDLER --------------------

function onVariantChange() {
  requestAnimationFrame(() => {
    updateShippingText();
    updateRate();
  });
}

// -------------------- SHIPPING --------------------

function addBusinessDays(date, days) {
  const result = new Date(date);
  let added = 0;

  while (added < days) {
    result.setDate(result.getDate() + 1);
    const d = result.getDay();
    if (d !== 0 && d !== 6) added++;
  }

  return result;
}

function updateShippingText() {
  const headers = document.querySelectorAll(".collapsible[data-days-min]");
  if (!headers.length) return;

  const today = new Date();

  const formatterDate = new Intl.DateTimeFormat(lang, {
    weekday: "long",
    day: "numeric",
    month: "long",
  });

  for (let i = 0; i < headers.length; i++) {
    const header = headers[i];

    const min = header.dataset.daysMin | 0;
    const max = header.dataset.daysMax ? header.dataset.daysMax | 0 : min;

    const dMin = addBusinessDays(today, min);
    const dMax = addBusinessDays(today, max);

    const formattedMin = formatterDate.format(dMin);
    const formattedMax = formatterDate.format(dMax);

    const idSuffix = header.id.replace("shipping-header-", "");
    const target = document.getElementById(`shippingText-${idSuffix}`);

    if (!target) continue;

    target.innerHTML =
      lang === "it"
        ? `Se ordini oggi lo spediremo fra <strong class="kalam-bold">${formattedMin}</strong> e <strong class="kalam-bold">${formattedMax}</strong>`
        : `If you order today we will ship between <strong class="kalam-bold">${formattedMin}</strong> and <strong class="kalam-bold">${formattedMax}</strong>`;
  }
}

// -------------------- RATE --------------------

function updateRate() {
  const priceList = document.querySelector("price-list");
  const rateSpan = document.getElementById("rateAmount");

  if (!priceList || !rateSpan) return;

  const price = priceList.dataset.price;

  if (!price) {
    rateSpan.textContent = "N/A";
    return;
  }

  const numeric = price * 1; // faster than parseFloat

  rateSpan.textContent = formatter.format(numeric / 3);
}